<template>
    <div class="row">
        <div class="col-12">
            <g-loading v-if="firstLoading" />
            <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSelected="false" @load="load" :isSearch='false' @reset="reset" 
                     :title="!parent_id ? 'Bình luận' : 'Trả lời bình luận'" titleIcon="fa fa-comments">
                <template slot="titlePage">
                    <p v-if="!parent_id"> Bình luận cho {{commentTypeOptions.find(o => o.value === type).text.toLowerCase()}}</p>
                    <p v-else> Danh sách trả lời bình luận </p>
                </template>
                <template slot="filter">
                    <user-select class="mr-1" placeHolder="Chọn tác giả"   :model="filterFormModel" :isFilter="true" @change="load"  attribute="user_id" />
                    <time-range-picker class="mr-2" :model="filterFormModel" label="Thời gian bình luận" :defaultShortcut="10" @change="load" />
                </template>
                <template slot="actionBefore">
                    <b-tabs class="c-tabs-button mr-2" small pills v-model="filterFormModel.status" @input="load">
                        <b-tab :title="params.tabAll"></b-tab>
                        <b-tab :title="params.tabNew"></b-tab>
                        <b-tab :title="params.tabApproved"></b-tab>
                        <b-tab :title="params.tabCancel"></b-tab>
                    </b-tabs>
                </template>
                <template slot="action">
                    <g-button class="ml-2" v-if="permissions('comment_create')" :loading="saveLoading" size="sm" variant="success" icon="plus" content="Thêm mới" @click="create" />
                </template>
                <template #cell(content)="{item}">
                    {{item.content}}
                    <div v-if="item.type && commentTypeOptions.find(o => o.value == item.type) && !parent_id">
                        <span v-if="item.target_id" class="small text-gray-999">{{commentTypeOptions.find(o => o.value === item.type).text}}: </span>
                        <span v-if='item.target_id && type === "news" && params.news && params.news[item.target_id]'>{{params.news[item.target_id] ? params.news[item.target_id].title : ''}}</span>
                        <span v-if='item.target_id && type === "policy" && params.policy && params.policy[item.target_id]'>{{params.policy[item.target_id] ? params.policy[item.target_id].title : ''}}</span>
                    </div>
                    <div><span class="small text-gray-999">Tác giả: </span>{{item.user_name}}</div>
                    <div v-if="!item.parent_id"><span class="small text-gray-999">Tổng số trả lời: </span>
                        <span v-if='params.countChild && params.countChild[item.id]'>{{params.countChild[item.id]}}</span> 
                        <span v-else>0</span> 
                    </div>
                </template>
                <template #cell(time)="{item}">
                    <div><span class="small text-gray-999">Ngày bình luận: </span>{{item.created_time * 1000 |  moment('HH:mm DD/MM/YYYY')}}</div>
                    <div v-if="item.approved_time  != null && item.approved_time  > 0 "><span class="small text-gray-999">Ngày duyệt: </span>{{item.approved_time * 1000 |  moment('HH:mm DD/MM/YYYY')}}</div>
                    <div v-if="item.cancel_time  != null && item.cancel_time  > 0 "><span class="small text-gray-999">Ngày từ chối: </span>{{item.cancel_time * 1000 |  moment('HH:mm DD/MM/YYYY')}}</div>
                    <div><span class="small text-gray-999">Trạng thái: </span>
                        <span v-if="item.approved_time && item.approved_time > 0 && item.cancel_time === 0" class="badge bg-success">Đã duyệt</span>
                        <span  v-if="item.approved_time === 0 && item.cancel_time === 0" class="badge bg-gray">Chờ duyệt</span>
                        <span v-if="item.cancel_time && item.cancel_time > 0" class="badge bg-danger">Từ chối</span>
                    </div>
                    <div v-if="item.cancel_time && item.cancel_time > 0"><span class="small text-gray-999">Lý do từ chối: </span>{{item.cancel_note}}</div>
                </template>
                <template #cell(action)="{item}">
                    <g-button v-if='!item.parent_id' :loading="updateLoading" size="sm" variant="outline-gray" class="ml-1 mb-1" icon="fa fa-comments" @click='commentChild(item)' content="Trả lời" />
                    <g-button v-if="permissions('comment_cancel') && item.cancel_time === 0" size="sm" variant="outline-gray" class="ml-1 mb-1" icon="fa fa-times" @click='cancel(item.id)' content="Từ chối"/>
                    <g-button  v-if="permissions('comment_update') " :loading="updateLoading" size="sm" variant="outline-gray" class="ml-1 mb-1" :icon="item.approved_time === 0 && (item.cancel_time > 0  || item.cancel_time === 0)? 'check' : 'pencil'" @click="update(item.id)" :content="item.approved_time === 0 && ( item.cancel_time > 0 || item.cancel_time === 0)? 'Duyệt' : 'Sửa'"/>
                    <g-button v-if="permissions('comment_del') && item.approved_time === 0"   :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1" icon="trash-fill" @click='del(item.id)' />
                </template>
            </g-table>
            <b-modal v-model="showForm" size="xl" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
                <div class="row" v-if='formModel.parent_id'>
                    <div class="col-md-12">
                        <form-checkbox  class='checkbox-label-bold' chkLabel="Admin trả lời" :model="formModel" attribute="admin_reply" :errors="formErrors" @change="isAdminRep()" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <user-select label="Tác giả" :disabled='formModel.parent_id != 0 && formModel.admin_reply == 1' :model="formModel" :errors="formErrors" @change='changeUser' attribute="user_id"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <form-input :required="true"  :disabled='formModel.user_id  || (formModel.parent_id != 0 && formModel.admin_reply == 1)' label="Họ và tên" :model="formModel" :errors="formErrors" attribute="user_name"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <form-input :disabled='formModel.user_id || (formModel.parent_id != 0 && formModel.admin_reply == 1)'   label="Số điện thoại" :model="formModel" :errors="formErrors" attribute="user_phone"/>
                    </div>
                    <div class="col-md-6">
                        <form-input   :disabled='formModel.user_id || (formModel.parent_id != 0 && formModel.admin_reply == 1)'  label="Email" :model="formModel" :errors="formErrors" attribute="user_email"/>
                    </div>
                </div>
                <div class="row" v-if='!formModel.parent_id'>
                    <div class="col-md-12">
                        <post-select v-if="type === 'post'" :disabled='!isAll'   label="Bài viết" :model="formModel" :errors="formErrors" attribute="target_id"/>
                    </div>
                </div>
                <div class="row" v-if='formModel.parent_id'>
                    <div class="col-md-12">
                        <form-textarea :disabled='formModel.parent_id' :model="formModel" label="Bình luận gốc"  :errors="formErrors" attribute="content_parent"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <form-textarea :required="true"  label="Nội dung bình luận" :model="formModel" :errors="formErrors" attribute="content"/>
                    </div>
                </div>
                <template v-slot:modal-footer="{ ok, cancel}">
                    <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                    <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                        <b-spinner v-if="saveLoading" small></b-spinner>
                        <em v-else class="fa fa-save" ></em>
                        {{formModel.approved_time === 0 && ( formModel.cancel_time > 0 || formModel.cancel_time === 0 ) ? 'Duyệt' : 'Lưu lại'}} 
                    </b-button>
                </template>
            </b-modal>
            <b-modal v-model="showFormCommentChild" size="xl" :title="formTitleCommentChild"   no-close-on-backdrop no-enforce-focus>
                <btn-comment :type='type' :parent_id='id_parent' :target_id='id_target' :itemParent='itemP'  />
                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import UserSelect from "@/components/UserSelect";
    import PostSelect from "@/components/PostSelect";
    import role from '@/mixins/Role';
    export default {
        components: {UserSelect,PostSelect},
        props: [
            "type",
            "target_id",
            "parent_id",
            "itemParent",
            "isAll"
        ],
        mixins: [list, crud, role],
        name: "BtnComment",
        data: function () {
            return {
                service: '/comment',
                fields: [
                    {key: 'content', label: "Bình luận"},
                    {key: 'time', label: "Thời gian"},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                    type: this.type,
                    status: 0,
                    target_id: this.target_id ? this.target_id : 0,
                    parent_id: this.parent_id ? this.parent_id : 0,
                },
                defaultFormModel: {
                    type: this.type,
                    target_id: this.target_id && this.target_id != 0 ? this.target_id : 0,
                    parent_id: this.parent_id ? this.parent_id : 0,
                    user_id: null,
                    user_name: this.parent_id ? 'Admin' : null,
                    user_email: null,
                    user_phone: null,
                    admin_reply: 1,
                    content_parent: this.itemParent ? this.itemParent.content : null
                },
                formModel: {
                    type: this.type,
                    target_id: this.target_id && this.target_id != 0 ? this.target_id : 0,
                    parent_id: this.parent_id ? this.parent_id : 0,
                    user_id: null,
                    user_name: null,
                    user_email: null,
                    user_phone: null,
                    content_parent: this.itemParent ? this.itemParent.content : null
                },
                commentTypeOptions: this.$params.commentTypeOptions,
                showFormCommentChild: false,
                formTitleCommentChild: null,
                id_parent: null,
                id_target: null,
                itemP: null
            };
        },
        methods: {
            cancel: function (id) {
                this.$swal({
                    icon: "warning",
                    text: "Bạn chắc chắn muốn từ chối bình luận?",
                    input: 'text',
                    inputPlaceholder: 'Nhập lý do từ chối',
                    confirmButtonText: "OK",
                    showCancelButton: true,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            if (value && value !== '') {
                                if (value.length > 500) {
                                    resolve('Lý do từ chối không được quá 500 ký tự');
                                } else {
                                    resolve();
                                }
                            } else {
                                resolve('Vui lòng nhập lý do từ chối bình luận');
                            }
                        })
                    }
                }).then((result) => {
                    if (result.isConfirmed && result.value) {
                        this.loading = true;
                        this.updateLoading = true;
                        let noteCancel = result.value === true ? '' : result.value;
                        let url = this.service + "/cancel?id=" + id + "&note=" + noteCancel;
                        return this.$service({url: url, method: 'put'}).then(response => {
                            if (this.load) {
                                this.load();
                            }
                            if (response.data) {
                                this.$swal({
                                    title: "",
                                    text: "Đã từ chối bình luận thành công.",
                                    icon: 'success',
                                    toast: true,
                                    position: 'bottom-end',
                                    timer: 5000,
                                });
                            } else {
                                this.$swal({
                                    title: "Có lỗi",
                                    text: "Từ chối thất bại",
                                    icon: 'error',
                                    toast: true,
                                    position: 'bottom-end',
                                    timer: 5000,
                                });
                            }
                            return response.data;
                        }).catch(error => {
                            if (error.response.data.message) {
                                this.$swal({
                                    text: error.response.data.message,
                                    icon: 'error'
                                });
                                this.showForm = false;
                            } else {
                                this.formErrors = error.response.data;
                            }
                        }).finally(() => {
                            this.loading = false;
                            this.updateLoading = false;
                        });
                    } else {
                        this.updateLoading = false;
                    }
                });
            },
            changeUser() {
                if (this.formModel.user_id) {
                    this.$service.get(`user/get?id=${this.formModel.user_id}`).then(response => {
                        if (response.data) {
                            this.formModel.user_name = response.data.name;
                            this.formModel.user_email = response.data.email;
                            this.formModel.user_phone = response.data.phone;
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.$swal({
                                text: error.response.data.message,
                                icon: 'error'
                            });
                        }
                    }).finally(() => {
                    });
                } else {
                    this.formModel.user_name = null;
                    this.formModel.user_email = null;
                    this.formModel.user_phone = null;
                }
            },
            isAdminRep: function () {
                if (this.formModel.admin_reply && this.formModel.admin_reply === '1') {
                    this.formModel.user_name = 'Admin';
                    this.formModel.user_id = null;
                    this.formModel.user_email = null;
                    this.formModel.user_phone = null;
                } else {
                    this.formModel.user_id = null;
                    this.formModel.user_name = null;
                    this.formModel.user_email = null;
                    this.formModel.user_phone = null;
                }
            },
            commentChild: function (item) {
                this.showFormCommentChild = true;
                this.formTitleCommentChild = "Danh sách trả lời bình luận của: " + item.content;
                this.id_parent = item.id;
                this.id_target = item.target_id;
                this.itemP = item;
            }
        },
    }
</script>